// @flow
import omit from '../utils/omit.js';
import {
  SET_PROGRESS,
  SET_MESSAGES,
  SET_MODAL,
  DEFAULT_GROUP,
  REMOVE_MESSAGES_BY_KEY,
  defaultUIState
} from './ui.const.js';

import type { UIState, Messages } from './ui.types.js';

export function UI(state: UIState = defaultUIState, action: Action) {
  switch (action.type) {
    case SET_PROGRESS:
      return {
        ...state,
        progress: action.payload.progress,
        elementsProgress: action.payload.identifier
          ? action.payload.progress
            ? {
                ...state.elementsProgress,
                [action.payload.identifier]: action.payload.progress
              }
            : omit(state.elementsProgress, action.payload.identifier)
          : state.elementsProgress
      };
    case SET_MESSAGES:
      return {
        ...state,
        messages: action.payload.messages
      };
    case REMOVE_MESSAGES_BY_KEY:
      return {
        ...state,
        messages: state.messages.filter(message => message.key !== action.payload.key)
      };
    case SET_MODAL:
      return {
        ...state,
        modals: action.payload.modalState
          ? {
              ...state.modals,
              [action.payload.identifier]: action.payload.modalState
            }
          : omit(state.modals, action.payload.identifier)
      };
    default:
      return state;
  }
}
